module.exports = __webpack_public_path__ + "static/TW-AUS-GFX-Research Heading-f87ecc021a39f029b9d483b1c18c13f8.png";